var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunburst(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 375 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 -495.3,203.5 -439.2,329.5",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 -384.8,411.9 -290.9,513.1",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 -212.9,573.4 -91.3,638.8",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 2.0,670.7 138.2,693.3",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 236.8,693.3 373.0,670.7",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 466.3,638.8 587.9,573.4",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 665.9,513.1 759.8,411.9",
    fill: "url(#raysGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5,-25 814.2,329.5 870.3,203.5",
    fill: "url(#raysGrad)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "raysGrad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.5 -25) scale(360)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B483",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F8CBA4",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE5C8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunburst);
export default __webpack_public_path__ + "static/media/sunburst.f7981d1c6acd7cbbc8b40859e2ad37b9.svg";
export { ForwardRef as ReactComponent };